// extracted by mini-css-extract-plugin
export default {"container_checkbox_delete_folders":"DeleteFolders_container_checkbox_delete_folders__E7KYL","subtitle_notifications":"DeleteFolders_subtitle_notifications__U6AC-"};